module.exports = __webpack_public_path__ + "img/kp47.a48fb7ce.png";